<template>
  <div class="ba6-domain-email-manager-card">
    <builderall-loader :loading="showLoading">
      <div class="ba6-card">
        <div class="ba6-top">
                <span class="ba6-main-icon ba-bg-green1">
                    <builderall-icon code='tools-email-engage'></builderall-icon>
                </span>
          <a :href="view.routes.dns" 
          class="ba6-title"
          style="max-width: 300px;">
          {{ t.dns_application_title }}</a>
        </div>
        <hr class="ba6-card-line">
        <div v-if="emptyDNSData" class="ba6-main-boxes">
          <a v-if="dnsData.domains > 0" :href="this.view.routes.dns_create_email" class="ba-btn ba-md ba-blue">
            {{ t.create_new_email }}
          </a>
          <a v-else :href="this.view.routes.dns_connect_domain" class="ba-btn ba-md ba-green">
            {{ t.domain_connection_wl }}
          </a>
        </div>
        <div v-else class="ba6-main">
          <div class="ba6-statistics">
            <div class="ba6-s-top">
              <div class="ba6-icon">
                <builderall-icon code='5151'></builderall-icon>
              </div>
              <div class="ba6-subtitle">{{ t['dns-connected-domains'] }}</div>
            </div>
            <span class="ba6-s-number" v-text="dnsData.domains"></span>
          </div>
          <hr class="ba6-s-line">
          <div class="ba6-statistics">
            <div class="ba6-s-top">
              <div class="ba6-icon">
                <builderall-icon code='message-group'></builderall-icon>
              </div>
              <div class="ba6-subtitle">{{ t.pro_email_accounts }}</div>
            </div>
            <span class="ba6-s-number" v-text="dnsData.emails"></span>
          </div>
        </div>
      </div>
    </builderall-loader>
    <builderall-enom v-if="view.load_enom_wc" :show="showBuyDomain"></builderall-enom>
  </div>
</template>

<script>
export default {
  name: "ba6-domain-email-manager-card",
  props: ['view'],
  data() {
    return {
      t: null,
      showBuyDomain: false,
      dnsData: {
        domains: 0,
        emails: 0
      },
      showLoading: false,
      emptyDNSData: true
    }
  },
  methods: {
    buyDomain() {
      this.showBuyDomain = true;
    },
    getDNSData() {
      this.showLoading = true
      const headers = {
        Accept: 'application/json',
        Authorization: this.view.token
      };

      fetch(`${this.view.routes.dns_manager}/api/v2/user/summary`, {
        method: 'GET',
        headers: headers
      })
        .then(response => response.json())
        .then(result => {
          this.dnsData = result.data
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => this.showLoading = false)
    }
  },
  created() {
    this.t = this.view.translations
    this.getDNSData()
  },
  watch: {
    dnsData(newVal) {
      this.emptyDNSData = isEmpty(newVal.domains) || isEmpty(newVal.emails) ? true : false
    }
  }
}
</script>

<style scoped lang="scss">
.ba6-main-boxes {
  a {
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/dashboard/domain-email-manager/DomainEmailManagerCard.vue